import { IDataCodigoOtp, ISolicitudCanje, ISolicitudEvento, MotivoRechazo, Pais, Plan, ProspectoTutorDescuento, Vendedor } from '..';
import { Empleado } from '../empleados';
import { ITrazabilidad } from '../global/trazabilidad.interface';

export interface IDataEstadosProspecto {
  codigo: number;
  nombre: string;
}

export interface IProspecto {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  num_pages: string | undefined;
  previous: string | undefined;
  data: IDataProspecto[];
}

export interface IDataProspecto {
  id_prospecto: string;
  pais_data: Pais;
  canal_venta_create: string;
  codigo?: string;
  numero_referencia?: string;
  tipo_identificacion: string;
  identificacion: string;
  razon_social: string;
  fecha_nacimiento: string;
  edad: number;
  celular: string;
  //condiciones prospecto
  es_discapacitado: boolean;
  es_tercera_edad: boolean;
  es_curador_tutor: boolean;
  es_bono_humano: boolean;
  es_reportado?: boolean; // score_bajo
  reportado?: boolean; //reportado por ISP
  estado_prospecto: string;
  estado: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  cliente: string | null;
  contrato: string | null;
  pais: string;
  nacionalidad: string;
  codigo_otp: string | null;
  linea: number | null;
  puntaje_score: string;
  puntaje_score_sobreendeudamiento: string
  puntaje_score_empresa: string;
  segmentacion: string;
  residencia_permanente: boolean;
  codigo_otp_data: IDataCodigoOtp | null;
  motivo_rechazo_data: MotivoRechazo | null;
  motivo_rechazo: string | null;
  //ruc
  tipo_contribuyente?: string;
  estado_contribuyente_ruc?: string;
  regimen?: string;
  actividad_economica_principal?: string;
  es_coorporativo?: boolean
  nombre_comercial?: string;

  //trazo:
  trazo_venta_data?: ITrazabilidad[];
  supervisor: Empleado;
  user_create?: string;

  ///* Aux
  observaciones: ObservacionProspecto;

  // persona beneficio
  identificacion_carga_personal?: string;
  razon_social_carga_personal?: string;

  ///* Fotos beneficio
  url_foto_tutor_discapacidad?: string;
  url_foto_documento_legal_representante?: string;
  url_foto_bono_desarrollo_humano?: string;

  es_ayuda_social: boolean

  email?: string;
  persona_contacto?: string;
  direccion?: string;
  es_pyme?: boolean

  vendedor_data?: Vendedor
  solicitud_evento: string;
  solicitud_canje: string;

  ///* gremio
  es_gremio?: boolean
  url_foto_identificacion_personal_gremio?: string
  url_foto_credencial_empresa?: string
  url_foto_documento_legal_empresa?: string

  ///* fk
  solictud_canje_data: Omit<ISolicitudCanje,
    'factibilidad_corporativa_data'
    | 'factibilidad_data'>
  solictud_evento_data: Omit<
    ISolicitudEvento,
    'factibilidad_corporativa_data'
    | 'factibilidad_data'
  >
}

interface ObservacionProspecto {
  observacion_cancelar?: string;
}

export interface IDataProspectoParams extends Partial<IDataProspecto> {
  page?: number;
  page_size?: number;
  user_create?: string;
  fecha_solicitud_after?: string | null;
  fecha_solicitud_before?: string | null;
}

export interface ICoordenadas {
  lat: number;
  lng: number;
}

export interface IFromProspecto {


  tipo_identificacion: string;
  identificacion: string;

  //cedula
  razon_social?: string;
  fecha_nacimiento?: string;
  edad?: number;
  celular: string;
  es_discapacitado?: boolean;
  es_tercera_edad?: boolean;
  pais?: string;
  nacionalidad?: string;
  residencia_permanente?: boolean
  es_coorporativo?: boolean
  linea?: number | null;

  //ruc
  tipo_contribuyente?: string
  estado_contribuyente_ruc?: string
  regimen?: string
  actividad_economica_principal?: string

  //buro crediticio
  puntaje_score?: number | string;
  puntaje_score_sobreendeudamiento?: number | string;
  puntaje_score_empresa?: number | string;
  segmentacion?: string;
  reportado?: boolean;

  //condiciones prospecto
  es_curador_tutor?: boolean;
  es_bono_humano?: boolean;
  es_ayuda_social?: boolean
  es_reportado?: boolean;

  //fotos beneficios
  url_foto_tutor_discapacidad?: string;
  url_foto_documento_legal_representante?: string;
  url_foto_bono_desarrollo_humano?: string;

  // persona beneficio

  observaciones?: ObservacionesCCorporativos;
  identificacion_carga_personal?: string;
  razon_social_carga_personal?: string;

  //no form
  tipo_identificacion_beneficio?: string;
  ced_beneficio_tutordiscapacidad?: string;
  nombre_beneficio_tutordiscapacidad?: string;
  bool_ced_beneficio_tutordiscapacidad?: boolean;
  observacion_vendedor?: string;
  solicitud_canje?: string;
  solicitud_evento?: string;
  id_solicitud_canje?: string;
  id_solicitud_evento?: string;
  es_pyme?: boolean
  condicion_venta?: string | null;
  condicion_identificacion?: string;

  es_gremio?: boolean
  url_foto_identificacion_personal_gremio?: string
  url_foto_credencial_empresa?: string
  url_foto_documento_legal_empresa?: string


  //*form
  observacion_solicitud?: string | null
}

export interface ObservacionesCCorporativos {
  observacion_vendedor?: string
  observacion_solicitud?: string | null
  observacion_prefactibilidad?: string
  observacion_preventa?: string
}


/* export interface IDataCedulaTemporal {
  code: number;
  message: string;
  data: IDataCedula;
  planes: { nombre:string }[]
} */


export interface IDataCedula {
  id_cliente: string;
  pais_data: any | null;
  provincia_data: any | null;
  ciudad_data: any | null;
  parroquia_data: any | null;
  zona_data: any | null;
  sector_data: any | null;
  codigo: string;
  numero_referencia: string;
  tipo_identificacion: string;
  identificacion: string;
  codigo_dactilar: string | null;
  razon_social: string;
  nombre?: string;
  fecha_nacimiento: string; // Formato de fecha ISO 8601
  edad: number;
  celular: string;
  es_discapacitado: boolean;
  es_tercera_edad: boolean;
  condicion_residencia: string | null;
  direccion: string;
  celular_2: string;
  email: string;
  coordenadas: any | null;
  lineas: number;
  estado: boolean;
  fecha_creacion: string; // Formato de fecha ISO 8601
  fecha_modificacion: string; // Formato de fecha ISO 8601
  pais: any | null;
  nacionalidad: any | null;
  provincia: any | null;
  ciudad: any | null;
  parroquia: any | null;
  zona: any | null;
  sector: any | null;
  planes: Plan[];
  discapacidad: boolean;
  estado_contribuyente_ruc: string
  ///* interface api externa
  razonSocial: string;
  tipoContribuyente: string;
  tipo_contribuyente: string;
  estadoContribuyenteRuc: string;
  regimen: string;
  actividadEconomicaPrincipal: string;
  deudas: IDeudas[] | null;
  condicionCedulado?: string;
  es_curador_tutor?: boolean;
  data_antiguos_contratos?: any[];
  prospectos_tutor_descuento?: ProspectoTutorDescuento[];
}

interface IDeudas {
  rubro: string
  concepto: string
  numeroCuota: any
  anio: string
  fechaInicioPago: string
  fechaVecimiento: string
  totalCuenta: string
  pendientePorCobrar: string
  estadoValor: string
}
//
export interface IDatosPersona {
  ok: number;
  CalleDomicilio: string;
  Cedula: string;
  CodigoError: string;
  CondicionCedulado: string;
  Conyuge: string;
  Domicilio: string;
  Error: string;
  EstadoCivil: string;
  FechaCedulacion: string;
  FechaNacimiento: string;
  Genero: string;
  Instruccion: string;
  LugarNacimiento: string;
  Nacionalidad: string;
  NombreMadre: string;
  NombrePadre: string;
  Nombre: string;
  NumeroDomicilio: string;
  Profesion: string;
}


export interface IEsClienteFibraMax {
  es_cliente: boolean;
}

export interface IDataRuc {
  id_empresa: number;
  ruc: string;
  razonSocial: string;
  estadoContribuyenteRuc: string;
  actividadEconomicaPrincipal: string;
  tipoContribuyente: string;
  regimen: string;
  categoria: string;
  obligadoLlevarContabilidad: string;
  agenteRetencion: string;
  contribuyenteEspecial: string;
  informacionFechasContribuyente: {
    fechaInicioActividades: string;
    fechaCese: string;
    fechaReinicioActividades: string;
    fechaActualizacion: string;
  };
  establecimientos: string | IDataEstablecimientos[]
  representantesLegales: string;
  motivoCancelacionSuspension: string;
  contribuyenteFantasma: string;
  transaccionesInexistente: string;
  //
  tipo_contribuyente: string
  estado_contribuyente_ruc: string

}

export interface IDataEstablecimientos {
  nombreFantasiaComercial: string | null;
}

export interface IDataPuntajeEquifax {
  code: number;
  message: string;
  status: string;
  data: {
    segmentacion: string;
    puntaje_score: number;
    puntaje_score_sobreendeudamiento: number;
    puntaje_empresa: number;
    dato_adicional: string;
  };
}


export interface FormVendedoProspecto {
  id_prospecto: string;
  vendedor_actual?: string;
  vendedor_nuevo: string;
}

export interface FormMotivoRechazoProspecto {
  id_prospecto: string;
  motivo_rechazo: string;
  razon_social?: string;
  identificacion?: string;
  observacion_cancelacion?: string;
}


export interface FormEditProspecto {
  id_prospecto: string;
  celular: string;
}


export interface IFiltrosGenerarExcelProspecto {
  fecha_solicitud_before?: string | null;
  fecha_solicitud_after?: string | null;
  provincia?: string | null;
  ciudad?: string | null;
  zona?: number | null;
  sector?: number | null;
  estado?: string | null;
  forma_pago?: string | null;
  tipo_documento?: string | null;
  edad?: number | null;
}

export enum RangoEdadEnum {
  EDAD_MAXIMA = 64,
  EDAD_MINIMA = 18
}

export interface IProspectOmitData extends Omit<IDataProspecto,
  'solictud_canje_data'
  | 'solictud_evento_data'> {

}